<template>
    <div>
        <template>
        <modal
        name="manageLcaPopupModal"
        classes="v-modal-sec linklca"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="750px"
        height="auto"
        >
        <div class="v-modal">
        <div class="popup-header fromDetailsPage"> 
        <h2 class="popup-title">
          {{popUpTitle}}

        </h2>
        <span @click="$modal.hide('manageLcaPopupModal');hideMe()">
          <em class="material-icons">close</em>
        </span>
        </div>
        <form data-vv-scope="newCaseNumberForm" @submit.prevent @keydown.enter.prevent>
          <div class="linklca_form" @click="formErrors=''">
            <div class=" linklca_form_header link_case">
                <div class="search">
                    <vs-input :key="'searchString'" icon-pack="feather" icon="icon-search"
                        :placeholder="'Search by Beneficiary Name/Petitioner Name/Case Number'"
                        class="is-label-placeholder" v-model.lazy="searchString" @input="casesSearch" />
                </div>
                <!-- /Receipt Number Receipt Number/ -->
            </div>
            <div class="form-container pad0 mt-0">
                <div class="accordian-table custom-table no-wrap relative">
                    <div class="search_LCA" v-if="!checksearchString"> 
                        <img src="@/assets/images/main/no-data.jpg"   />
                        <p>Search by Beneficiary Name/Petitioner Name/Case Number </p>
                    </div>
                    
                    <NoDataFound ref="NoDataFoundRef" :loading="isListLoading" v-if="casesList.length == 0 && checksearchString" content=""
                    :heading="'No Results Found'" type='petitions' />
                    <template v-if="casesList.length > 0 && checksearchString">
                    <div>
                        <template>
                            <div class="padb50">
                                <div class="cases_search_list" :key="indextr" v-for="(tr, indextr) in casesList">
                                    <div class="d-flex justify-content-between">
                                        <div class="cases_search_title">
                                            <vs-checkbox 
                                                @change="selectForLca(tr)" :name="'selected_'+tr.indextr"
                                                v-model="tr.selectedForLca"
                                                class="" v-if="checkProperty(tr, 'caseNo')"> {{ checkProperty(tr, 'caseNo')}}</vs-checkbox>
                                            <span class="case-type" v-if="checkProperty(tr, 'typeName')">{{ checkProperty(tr, 'typeName')}}<em v-if="checkProperty(tr, 'subTypeName')">({{ checkProperty(tr, 'subTypeName') }})</em></span>
                                        </div>
                                        



                                        <span :statusId="checkProperty(tr, 'statusDetails', 'id')" class="statusspan"
                                            v-bind:class="{ [getCaseColors(checkProperty(tr, 'statusDetails', 'id'))]: true }">
                                            {{ checkProperty(tr, 'statusDetails', 'name')}}
                                        </span>
                                    </div>
                                    
                                    <div class="list_items list___items">
                                        <ul class="d-flex">
                                        <!-- <li>
                                            <span v-if="checkProperty(tr, 'typeName')">{{ checkProperty(tr, 'typeName')}}<em v-if="checkProperty(tr, 'subTypeName')">({{ checkProperty(tr, 'subTypeName') }})</em></span>
                                        </li> -->
                                        <li class="member">
                                            <span v-if="checkProperty(tr, 'beneficiaryDetails','name')">{{ checkProperty(tr, 'beneficiaryDetails','name') }}<em>(Beneficiary)</em></span></li>
                                            <li class="member">
                                            <span v-if="checkProperty(tr, 'petitionerDetails','name')">{{  checkProperty(tr, 'petitionerDetails','name') }}<em>(Petitioner)</em></span></li>
                                        </ul>
                                    </div>
                                    <div class="custom-radio_wrap wf_radio radio_wrapV2" v-if="checkProperty(tr, 'selectedForLca')">
                                        <ul class="custom-radio mb-1" >
                                            <li> 
                                                <vs-radio @input="openReceiptPopup(tr)" :name="'documentType'+indextr"  vs-value="Receipt" v-model="tr.selectedDocumentType" class="w-full" >Receipt Notice</vs-radio>
                                            </li>
                                            <li>
                                                <vs-radio @input="openReceiptPopup(tr)" :name="'documentType'+indextr"   vs-value="Notices"  v-model="tr.selectedDocumentType" class="w-full" >USCIS Notice</vs-radio>
                                            </li>
                                            
                                        </ul>
                                    </div>
                                  
                                </div>
                            </div>
                        </template>
                    </div>
                    </template>
                </div>            
                
            </div>

            <div class="popup-footer linkcase relative">
                <div class="text-danger text-sm formerrors my-2" v-show="formErrors">
                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius"
                        icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formErrors }}</vs-alert>
                </div>
                <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif" /></span>
                <vs-button color="dark" @click="showPopup = false" class="cancel" type="filled">Cancel</vs-button>


                <vs-button v-if="false" :disabled="loading || !checkSubmitBtn || checkProperty( casesList,'length')<=0" color="success" @click="submitForm()" class="save" type="filled">
                    <template>Link with Case</template>
                </vs-button>

            </div>
          </div>
        </form>
      </div>
        </modal>
        </template>
        <template>
       <receiptUpdates :aiReqCronId="aiReqCronId" :documentDetail="updatedSelectedDoc" :caseCurrentDetails="caseCurrentDetails" :petition="selectedPetition" @hideReceipt="hideReceipt" v-if="showReceiptUpdates" />
       <noticesUpdates :aiReqCronId="aiReqCronId" :documentDetail="updatedSelectedDoc" :caseCurrentDetails="caseCurrentDetails" :petition="selectedPetition" @hideNotice="hideNotice" v-if="showNoticeUpdates" />
    </template>
    </div>
 
</template>
<script> 
import RequestLCA from "@/views/RequestLCA";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import * as _ from "lodash";
import { XIcon, MoreVerticalIcon } from 'vue-feather-icons'
import Vue from 'vue';
Vue.use(CKEditor);
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import NoDataFound from "@/views/common/noData.vue";
import receiptUpdates from "@/views/documentAiTools/receiptUpdates";
import noticesUpdates from "@/views/documentAiTools/noticesUpdates";

export default {
    methods: {
        hideReceipt(callFromSuccess = false){
            this.showReceiptUpdates = false;
            if(callFromSuccess){
                this.hideMe()
            }else{
                this.reloadPetition();
            }
        },
        hideNotice(callFromSuccess = false){
            this.showNoticeUpdates = false;
            if(callFromSuccess){
                this.hideMe()
            }else{
                this.reloadPetition();
            }
        },
        openReceiptPopup(tr){
            
            if(this.checkProperty(tr ,'selectedDocumentType') ==  'Receipt' && this.selectedPetition !=null){
                this.showReceiptUpdates = true;
                this.showNoticeUpdates = false;
            }
            if(this.checkProperty(tr ,'selectedDocumentType') ==  'Notices'  && this.selectedPetition !=null){
                this.showReceiptUpdates = false;
                this.showNoticeUpdates = true;
            }
        },
        reloadPetition(){
            if(this.checkProperty(this.selectedPetition, '_id')){
                if(this.checkProperty(this.selectedPetition, 'typeDetails', 'id') == 3 && this.checkProperty(this.selectedPetition, 'subTypeDetails', 'id') == 15){ 
                    let path= "/perm/details";
                    let postData = {"petitionId":''};
                    postData['petitionId'] = this.checkProperty(this.selectedPetition ,'_id');
                this.$store.dispatch("commonAction", {"data":postData ,"path":path})
                    .then(response => {
                        if(response){ 
                            this.selectedPetition = response;
                        }
                    })
                }else{
                    this.getCaseCurrentDetails(this.checkProperty(this.selectedPetition ,'_id'))
                    this.$store.dispatch("getpetition", this.checkProperty(this.selectedPetition ,'_id')).then((response) => {
                        if (response && response.data && response.data.result ) {
                            this.selectedPetition = response.data.result;

                        }
                    })
                }
            }
        },
        selectForLca(tr){
            this.caseCurrentDetails = [];
            this.selectedPetition = null;
            let self = this;
           
            if(this.checkProperty(tr ,'selectedForLca') && self.checkProperty(tr,'_id') && this.checkProperty(this.casesList,'length')>0 ){
                _.forEach( this.casesList,(item) => {
                    if(item['_id'] != self.checkProperty(tr,'_id') ){
                        item['selectedForLca'] = false;
                        item['selectedDocumentType'] = '';
                    }
                })
            }
            if(this.checkProperty(tr ,'selectedForLca')){
                if(this.checkProperty(tr ,'type') == 3 && this.checkProperty(tr ,'subType') == 15 ){
                    let path= "/perm/details";
                    let postData = {"petitionId":''};
                    postData['petitionId'] = this.checkProperty(tr ,'_id');
                    this.$store.dispatch("commonAction", {"data":postData ,"path":path})
                    .then(response => {
                        if(response){ 
                            this.selectedPetition = response;
                        }
                    })
                }else{
                    this.getCaseCurrentDetails(this.checkProperty(tr ,'_id'))
                    this.$store.dispatch("getpetition", this.checkProperty(tr ,'_id')).then((response) => {
                        if (response && response.data && response.data.result ) {
                            this.selectedPetition = response.data.result;

                        }
                    }) 
                }
            }
        },
        getCaseCurrentDetails(petitionId) {
            if (petitionId) {
                let self = this;
                let postData = {
                    petitionId: petitionId,
                };
                this.caseCurrentDetails = [];
                this.$store.dispatch("commonAction", {
                    data: postData,
                    path: "petition/get-current-at-details",
                })
                .then((response) => {
                    if (this.checkProperty(response, "agingLogs")) {
                        this.caseCurrentDetails = response["agingLogs"];
                    }
                });
            }
        },
        getCasesList() {
            if (this.cancelTokenSource) {
                this.cancelTokenSource.abort()
            }
            let obj = {
                "filters": {
                    "title": this.searchString,//Beneficiary Name, Petitioner Name, Receipt Number and Case Number.
                    'category':this.checkProperty(this.documentDetail, 'caseData','doc_type')
                },
            }
            this.cancelTokenSource = new AbortController();
            const signal = this.cancelTokenSource.signal;
            // this.$store.dispatch("commonAction", { "data": postdata, "path": 'ai-tools/case-list' }).then(response => {
            this.$store.dispatch("fetchaicaselistWithAbort", {postdata:obj,cancelTokenSource: signal}).then(response => {
                this.casesList  = [];
               this.updateLoading(false);
               setTimeout(()=>{
                this.updateLoading(false);
               })
                let list = _.cloneDeep(response.data.result);
                let tempList = [];
                if(this.lcaId){
                    tempList = _.filter(list,(ite)=>{
                     return ite['_id'] != this.lcaId
                    })
                }else{
                    tempList = _.cloneDeep(list)
                }
                let modifiedList = [];
                _.forEach(tempList ,(item)=>{
                    item =Object.assign(item,{ 'selectedForLca':false, 'selectedDocumentType':''});
                    modifiedList.push(item);

                });
                if(modifiedList && this.checkProperty(modifiedList,'length')>0){
                    _.forEach(modifiedList,(item)=>{
                        if(_.has(item,'benificiaryName') && this.checkProperty(item, 'benificiaryName')){
                        let tempWord = item['benificiaryName'].split(',')
                        if(tempWord){
                            Object.assign(item,{'benificiaryNameList':tempWord})
                        }
                        }
                    })
                    this.casesList = _.cloneDeep(modifiedList);
                }

            }).catch(() => {
                this.updateLoading(false);

            })
        },
        submitForm() {

            this.$validator.validateAll("assignmentForm").then((result) => {
                let findItem = _.find(this.casesList,{ 'selectedForLca':true})
                if (findItem) {
                        let postData = {
                        };
                        if (this.checkProperty(findItem, '_id')) {
                            postData['petitionId'] = findItem['_id']
                        }
                        if(this.checkProperty(this.documentDetail, '_id')){
                            postData['aiReqCronId'] = this.documentDetail['_id']
                        }
                        let path = "/ai-tools/link-with-case-and-complete-process";
                        this.loading = true;
                        this.$store
                            .dispatch("commonAction", { "data": postData, "path": path })
                            .then(response => {
                                this.$emit("updateDetails");
                                this.$emit("hideMe");
                                this.showPopup = false;
                                this.$modal.hide('manageLcaPopupModal')
                                this.showToster({ message: response.message, isError: false });
                                this.loading = false;
                               
                            })
                            .catch((error) => {
                                this.formErrors = error;
                                this.loading = false;
                            //    this.showToster({ message: error, isError: true });
                            //    this.$modal.hide('manageLcaPopupModal')
                            //    this.$emit("updateDetails");
                            //     this.$emit("hideMe");
                            })
                }else{
                    this.showToster({ message: 'Please select Case', isError: true });
                }
            });
        },
        hideMe() {
            this.$emit("hideMe");
        },
        casesSearch(searchValue) {
            // let text = this.searchString.trim();
              this.casesList =[];
            if(this.checksearchString){
                clearTimeout(this.debounce)
                    this.debounce = setTimeout(() => {
                    this.getCasesList()
                    }, 900)
            }else{
                this.casesList = [];
            }
            
        },

    },
    watch: {
        showPopup(val) {
            if (!val) this.$emit("hideMe");
            if(!val){
                this.$modal.hide('manageLcaPopupModal');
            }
            
        },
    },
    mounted() {
        if(this.checkProperty(this.documentDetail, '_id')){
            this.aiReqCronId = this.checkProperty(this.documentDetail, '_id');
        }
        
        this.showPopup = true;
        this.$modal.show('manageLcaPopupModal');
        this.searchString="";
        if(this.documentDetail && this.checkProperty(this.documentDetail, 'document')){
            let obj = this.checkProperty(this.documentDetail, 'document');
            if(this.documentDetail && this.checkProperty(this.documentDetail, 'createdBy')){
                obj['uploadedBy'] = this.checkProperty(this.documentDetail, 'createdBy');
            }
            if(this.documentDetail && this.checkProperty(this.documentDetail, 'createdByName')){
                obj['uploadedByName'] = this.checkProperty(this.documentDetail, 'createdByName');
            }
            if(this.documentDetail && this.checkProperty(this.documentDetail, 'createdByRoleId')){
                obj['uploadedByRoleId'] = this.checkProperty(this.documentDetail, 'createdByRoleId');
            }
            if(this.documentDetail && this.checkProperty(this.documentDetail, 'createdByRoleName')){
                obj['uploadedByRoleName'] = this.checkProperty(this.documentDetail, 'createdByRoleName');
            }
            this.updatedSelectedDoc = obj;
        }
        
      
    },
    data: () => ({
        aiReqCronId:'',
        caseCurrentDetails:[],
        updatedSelectedDoc:null,
        showNoticeUpdates:false,
        showReceiptUpdates:false,
        selectedPetition:null,
        selectedDocumentType:'',
        cancelTokenSource: null,
        settings: { 
            swipeEasing: true,
        },
        isListLoading:false,
        sortKeys: {},
        sortKey: {},
        searchtxt:'',
        debounce:null,
        editor: ClassicEditor,
        editorConfig: {
            toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
        },
        loading: false,
        comments: null,
        showPopup: false,
        formErrors: null,
        lcaInfo: null,
        casesList:[],
        linkedCaseList: [],
        selectedCaseNos: [],
        dropdownTitle: 'Case No',
        searchString: ''

    }),
    props: {
        ACTIVITYCODE: {
            type: String,
            default: null,
        },
        rolesList: [],
        popUpTitle: {
            type: String,
            default: null,
        },
        documentDetail: {
            type: Object,
            default: null,
        },
        lcaId: {
            type: String,
            default: '',
        },
        // selectedCaseItem: {
        //     type: Object,
        //     default: null,
        // },
        isFromPetition: {
            type: Boolean,
            default: null,
        },


    },
    components:{
        XIcon,
        NoDataFound,
        MoreVerticalIcon,
        RequestLCA,
        VuePerfectScrollbar,
        receiptUpdates,
        noticesUpdates
    },
    computed:{
        checkSubmitBtn(){
           if( _.find( this.casesList, {'selectedForLca':true })){
            return true;

           }else{
            return false
           }
        },
        checksearchString(){
            let returnVal = false;
            let text = this.searchString.trim();
            if(text.length>=1){
                returnVal = true;
            }
            return returnVal
        }
        
    }
};
</script>
  